var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatsTeardropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2477 5.68785C12.682 4.36359 11.6765 3.27528 10.401 2.60689C9.12553 1.9385 7.65839 1.73105 6.2476 2.0196C4.83682 2.30815 3.56895 3.075 2.65834 4.19052C1.74773 5.30603 1.25025 6.70176 1.25 8.14175V13.298C1.25 13.5881 1.36523 13.8663 1.57035 14.0714C1.77547 14.2765 2.05367 14.3918 2.34375 14.3918H6.77109C7.25882 15.5055 8.06026 16.4532 9.07758 17.1192C10.0949 17.7851 11.2841 18.1404 12.5 18.1418H17.6562C17.9463 18.1418 18.2245 18.0265 18.4296 17.8214C18.6348 17.6163 18.75 17.3381 18.75 17.048V11.8918C18.7497 10.3638 18.1897 8.88895 17.1759 7.74585C16.1621 6.60275 14.7646 5.87062 13.2477 5.68785ZM17.5 16.8918H12.5C11.6159 16.8907 10.7477 16.6558 9.98375 16.2109C9.21976 15.7659 8.5871 15.1267 8.15 14.3582C9.00603 14.2693 9.83445 14.0045 10.5833 13.5803C11.3321 13.1561 11.9852 12.5817 12.5015 11.8932C13.0178 11.2046 13.3862 10.4168 13.5836 9.5791C13.7809 8.74142 13.803 7.87198 13.6484 7.02535C14.7447 7.28407 15.7216 7.9054 16.4206 8.78865C17.1197 9.67191 17.5 10.7653 17.5 11.8918V16.8918Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsTeardropIcon);
export default __webpack_public_path__ + "static/media/ChatsTeardropIcon.97664892.svg";
export { ForwardRef as ReactComponent };